/** Libellé meeting sur une carte division. */
export function formatDivisionMeetingLabel(meetingNumber: number, meetingCount: number): string {
  return `Meeting ${meetingNumber} / ${meetingCount}`;
}

/**
 * Libellé global de progression. Si les divisions ne sont pas au même meeting,
 * affiche la plage min–max pour éviter « Meeting 2 » alors qu’une piste est encore en 1.
 */
export function formatGlobalMeetingProgress(
  meetingIndices: readonly number[],
  meetingCount: number
): string {
  const valid = meetingIndices.filter((n) => Number.isFinite(n) && n >= 1);
  if (valid.length === 0) {
    return `Meeting 1 / ${meetingCount}`;
  }
  const min = Math.min(...valid);
  const max = Math.max(...valid);
  if (min === max) {
    return `Meeting ${min} / ${meetingCount}`;
  }
  return `Meetings ${min}–${max} / ${meetingCount}`;
}
